<div class="footer-container">

<!-- Bloque 1 -->
<div class="formulario">
  <h2 class="typography-title-m my-0">{{ 'rewards.Te_ha_resultado_til_el_contenido_de_esta_p_gina' | translate }}</h2>
  <div class="formulario-top">
    <!-- Columna izquierda -->
    <div class="formulario-left">
      <p class="typography-body-l-medium my-0">{{ 'rewards.rating_exp' | translate }}</p>

      <div class="rating">
        <ng-container *ngFor="let star of [1,2,3,4,5]">
          <span
                class="star"
                [class.filled]="star <= (hoverValoracion || valoracion)"
                (mouseenter)="setHover(star)"
                (mouseleave)="clearHover()"
                (click)="setValoracion(star)">
            <svg class={classSvg} width=48 height=48 viewBox="0 0 38 37"  xmlns="http://www.w3.org/2000/svg">
              <path class={classPath}
                    d="M17.0979 1.8541C17.6966 0.0114822 20.3034 0.0114799 20.9021 1.8541L23.9393 11.2016C24.2071 12.0257 24.975 12.5836 25.8414 12.5836H35.67C37.6074 12.5836 38.413 15.0628 36.8456 16.2016L28.8941 21.9787C28.1931 22.488 27.8998 23.3907 28.1675 24.2148L31.2047 33.5623C31.8034 35.4049 29.6945 36.9372 28.127 35.7984L20.1756 30.0213C19.4746 29.512 18.5254 29.512 17.8244 30.0213L9.87295 35.7984C8.30553 36.9372 6.19656 35.4049 6.79527 33.5623L9.83246 24.2148C10.1002 23.3907 9.80689 22.488 9.10592 21.9787L1.15444 16.2016C-0.412985 15.0628 0.392565 12.5836 2.33001 12.5836H12.1586C13.025 12.5836 13.7929 12.0257 14.0607 11.2016L17.0979 1.8541Z"
                    [attr.fill]="(star <= (hoverValoracion || valoracion)) ? '#365BCA' : '#DDE4F6'"/>
            </svg>
          </span>
        </ng-container>
      </div>

      <div class="rating-labels">
        <span>{{ 'rewards.rating1' | translate }}</span>
        <span>{{ 'rewards.rating5' | translate }}</span>
      </div>
    </div>

    <!-- Columna derecha -->
    <div class="formulario-right">
      <label for="comentario" class="pb-2">{{ 'rewards.comentario_rating' | translate }}</label>
      <textarea
        id="comentario"
        [value]="comentario"
        (input)="onComentarioInput($event)">
      </textarea>
    </div>
  </div>

  <!-- Divider -->
  <div class="divider"></div>

  <!-- Botón -->
  <div class="formulario-bottom">
    <app-button
          [primary]="true"
          size="'medium'"
          (click)="submit()"
          [disabled]="isSubmitting">
      <span class="typography-body-m-medium">
        {{ 'rewards.csat_send_valoration' | translate }}
      </span>
    </app-button>
  </div>
</div>


  <!-- Bloque 2 -->
  <div class="contacto">
    <div class="info">
      <div>
        <span class="typography-title-l responsiveMobile"><strong>{{ 'rewards.footer_title_question' | translate }} </strong></span><br>
        <span class="typography-body-m-light responsiveMobile2">{{ 'rewards.footer_subtitle' | translate }}</span>
      </div>
      <div class="linea"></div>
      <div class="contact-data">
        <div class="typography-body-m-medium responsiveMobile">
          {{ 'rewards.footer_contact_telf' | translate }}
          <span class="blueLabel">
            <app-cosentino-svg class="icon" [svgName]="'mobile'" [size]="16"></app-cosentino-svg>{{ telefono }}
          </span>
        </div>
        <div class="typography-body-m-medium responsiveMobile">
          {{ 'rewards.footer_contact_mail' | translate }}
          <span class="blueLabel">
            <app-cosentino-svg class="icon" [svgName]="'mail'" [size]="16"></app-cosentino-svg>{{ email }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
